import { useContext } from 'react';

import { FeatureFlagNames } from 'components/CRM/Common/featureFlags';
import { MyQueueContext, MyQueueContextType } from 'components/CRM/contexts/MyQueueContext';
import { FeatureFlag } from 'interfaces/FeatureFlag';

// use this for class components (because can't use hooks)
export const getIsFeatureFlagActive = (featureFlags: FeatureFlag[] | null | undefined, flagName: FeatureFlagNames) => {
    return !!featureFlags?.find((flag) => flag.name === flagName && flag.isActive);
};

const useIsFeatureFlagActive = (flagName: FeatureFlagNames) => {
    const myQueueContext = useContext<MyQueueContextType>(MyQueueContext);
    const { featureFlags } = myQueueContext?.initialData ?? {};
    return !!featureFlags?.find((flag) => flag.name === flagName && flag.isActive);
};

export default useIsFeatureFlagActive;
